import { render, staticRenderFns } from "./DonutChart2.vue?vue&type=template&id=46a9f4df&scoped=true"
import script from "./DonutChart2.vue?vue&type=script&lang=js"
export * from "./DonutChart2.vue?vue&type=script&lang=js"
import style0 from "./DonutChart2.vue?vue&type=style&index=0&id=46a9f4df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a9f4df",
  null
  
)

export default component.exports